import styled, { css } from 'styled-components/macro';
import { maxWidthDefault } from '../../../styles/utils';
import CalendarFilter from '../../../components/CalendarFilter';
import CsvFilter from '../../../components/CsvFilter';

export const FiltersDiv = styled.div`
  flex-grow: 1;
  max-width: 100%;
  margin-bottom: 10px;
  ${props =>
    props.titleRow &&
    css`
      @media screen and (min-width: 1024px) {
        max-width: 650px;
        margin-left: auto;
      }
    `}
  @media screen and (min-width: 1440px) {
    max-width: ${maxWidthDefault - 160}px;
  }
`;

export const FiltersSectionDiv = styled.div`
  display: flex;
  height: 4rem;
  align-items: flex-start;
  border: ${props => props.theme.defaultBorder};
  background-color: white;
  @media screen and (max-width: 767px) {
    margin-top: 1rem;
  }
  ${props =>
    props.payoutsMobileCustom &&
    css`
      border: 1px solid ${props => props.theme.brand};
      display: flex;
      justify-content: space-between;
      flex-grow: 1;
      padding: 0px 1.5rem;
      align-items: center;
      > p {
        color: ${props => props.theme.brand};
        margin-right: 1rem;
      }
    `}
`;

export const CustomCalendarFilter = styled(CalendarFilter)`
  /* width: 205px;
  ${props =>
    props.calendarStart &&
    props.calendarEnd &&
    css`
      justify-content: space-between;
    `} */
`;

export const CustomCsvFilter = styled(CsvFilter)`
  flex-grow: unset;
  padding-right: 0;
`;

export const StatusDiv = styled.div`
  > svg {
    margin-right: 7px;
  }
  display: flex;
  justify-content: flex-end;
`;

export const StatusP = styled.span`
  color: ${props => props.theme[props.color]};
`;
